
import { Moment } from 'moment';
import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
const getUrl = require('baimahu/url-with-param');
const dateFormat = require('bmh/date-format');
const Hundun = namespace('Hundun');
const { VUE_APP_FCAPI: FCAPI } = process.env;
import client from 'baimahu/client';
const API = {
  change_log: `${FCAPI}/boss/hundun/user/log`,
  edit_user_detail: `${FCAPI}/boss/hundun/user/attribute`,
  get_list: `${FCAPI}/boss/hundun/work/cooperation`,
  delete_tag: `${FCAPI}/boss/hundun/user/tag`,
  more_change: `${FCAPI}/boss/hundun/work/cooperation/99999`,
  product_menu: `${FCAPI}/boss/setting/auth/product/menu`
};
interface from {
  charge_teacher_id: number[];
  follow_status: string;
  cooperation_status: number;
  visit_time: Moment[];
  branch_id: number;
  mobile: string;
}
function initForm() {
  return {
    charge_teacher_id: [],
    follow_status: '0',
    cooperation: 0,
    visit_time: [],
    branch_id: 0,
    mobile: ''
  };
}
@Component
export default class RegisterList extends Vue {
  /* eslint-disable */
  // @ts-ignore
  @Hundun.State('teacher_list') teacher_list: any; //负责班主任
  // @ts-ignore
  @Hundun.State('follow_status') follow_status: any; //跟进状态选项
  // @ts-ignore
  @Hundun.State('branch_office') branch_office: any; //分社选项
  // @ts-ignore
  @Hundun.State('tag_list') tag_list: any; //标签
  /* eslint-enable */
  get follow_status_without_all() {
    return [
      {
        id: '1',
        value: '已加'
      },
      {
        id: '2',
        value: '团报'
      },
      {
        id: '3',
        value: '删'
      },
      {
        id: '4',
        value: '微信待通过'
      },
      {
        id: '5',
        value: '已发短信'
      },
      {
        id: '6',
        value: '微信非手机号'
      },
      {
        id: '7',
        value: '已电话沟通'
      },
      {
        id: '99',
        value: '其他'
      }
    ];
  }
  get teacher_width_none() {
    let s = [...this.teacher_list];
    return s.slice(1);
  }
  get tag_without_all() {
    let s = [...this.tag_list];
    s.pop();
    return s;
  }
  form = initForm();
  show_add_tag = false; //添加标签
  show_change_modal = false; //批量修改弹框
  is_loading = false;
  table_data: any = {
    //表格数据
  };
  more_form: any;
  user: any = {};
  tag_value = [];
  log: string[] = []; //班主任备注
  locale = zhCN;
  select_row_key = []; //被选中项
  is_show_waring_select_all = false;
  is_select_all = false;
  window = window as any;
  user_list_id = '';
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d');
  }
  //批量修改
  showChangeModal() {
    console.log(this.more_form.getFieldsValue());
    if (this.select_row_key.length === 0) {
      this.$message.error('请先选择要修改的用户');
      return;
    }
    // this.more_form.resetFields();
    this.show_change_modal = true;
  }
  confirmSelectAll() {
    this.select_row_key = this.table_data.detail.map((item: any) => item.id);
    this.is_show_waring_select_all = false;
  }
  //确认批量修改
  confirmMoreChange() {
    this.more_form.validateFields(async (err: any, values: any) => {
      console.log(err);
      if (!err) {
        const send_data = {
          id_str: this.select_row_key.join(','),
          cooperation_type: values.second
        };
        const res: any = await this.$axios.put(API.more_change, send_data);
        if (res.data.status === 200) {
          this.$message.success('编辑成功');
          this.select_row_key = [];
          this.search(this.table_data.current);
          this.show_change_modal = false;
          // this.select_row_key = [];
        }
      }
    });
  }
  check(record: any) {
    this.$router.push(`/hundun/user-detail/${record.id}?menu_id=${this.window.route_menu_id}`);
  }
  clear() {
    this.is_select_all = false;
    this.form = initForm();
  }
  //添加备注
  async addLog(id: any, index: number) {
    //修改班主任备注
    if (!this.log[index]) {
      return;
    }
    const send_data = {
      user_id: id,
      content: this.log[index]
    };
    const res: any = await this.$axios.post(`${API.change_log}?menu_id=${(window as any).route_menu_id}`, send_data);
    if (res.status == 200) {
      this.$message.success('提交成功');
      this.search(this.table_data.current);
      this.log[index] = '';
    }
  }
  //修改异业合作类型
  async changeCooperation(record: any) {
    const send_data = {
      id_str: String(record.id),
      cooperation_type: record.cooperation_type
    };
    const res: any = await this.$axios.put(API.more_change, send_data);
    if (res.status === 200) {
      this.$message.success('编辑成功');
      this.search(this.table_data.current);
    }
  }
  filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  //添加标签
  addTag(record: any) {
    this.user = record;
    this.tag_value = [];
    this.show_add_tag = true;
  }
  //确认添加标签
  confirmAdd() {
    const value = this.tag_value.pop();
    this.editDetail('tag', value, this.user);
    this.show_add_tag = false;
  }
  //删除标签
  async deleteTag(id: number) {
    const res: any = await this.$axios.delete(`${API.delete_tag}/${id}?menu_id=${(window as any).route_menu_id}`);
    if (res.data.status == 200) {
      this.$message.success('删除成功');
      this.search(this.table_data.current);
      return;
    }
  }
  // 分页
  paginationOption(remote: any) {
    return {
      current: +remote.current || 0,
      total: remote.total || 0,
      pageSize: remote.limit || 0,
      showTotal: () => `共${remote.total}条，每页${remote.limit}条`
    };
  }
  // 切换分页
  changePage(page: any) {
    this.search(page.current);
  }
  //修改跟进状态
  async editDetail(column: string, value: any, record: any) {
    if (column === 'cooperation' && value.length === 1) {
      //合作如果是1级则二级放空
      value.push('');
    }
    const send_data = {
      column: column,
      value: value
    };
    const res = await this.$axios.put(`${API.edit_user_detail}/${record.id}?menu_id=${(window as any).route_menu_id}`, send_data);
    if (res.data.status === 200) {
      this.search(this.table_data.current);
      this.$message.success('编辑成功');
    }
  }
  //搜索
  async search(page = 1) {
    this.is_loading = true;
    const start_time = this.form.visit_time[0] ? Math.floor((this.form.visit_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const end_time = this.form.visit_time[1] ? Math.floor((this.form.visit_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 86400 : '';
    const send_data = {
      mobile: this.form.mobile ? this.form.mobile : '',
      charge_teacher_id: this.form.charge_teacher_id.length === 0 ? '' : this.form.charge_teacher_id,
      follow_status: this.form.follow_status === '0' ? '' : this.form.follow_status,
      start_time: start_time,
      end_time: end_time,
      current: page,
      branch_id: this.form.branch_id === 0 ? '' : this.form.branch_id,
      page: 20,
      cooperation_type: this.form.cooperation === 0 ? '' : this.form.cooperation
    };
    const url = getUrl(API.get_list, send_data);
    const res: any = await this.$axios.get(url);
    if (res.status === 200) {
      this.table_data = res.data.data ? res.data.data : [];
      if (this.table_data.detail && this.table_data.detail.length > 0) {
        this.table_data.detail.forEach((item: any) => {
          if (item.cooperation_type === 0) {
            item.cooperation_type = 1;
          }
        });
      }

      this.is_loading = false;
    }
    this.select_row_key = [];
  }
  rowKey(record: any) {
    return record.id;
  }
  onSelectChange(select_row_key: any) {
    //选择钩子函数
    console.log('select_row_key changed: ', select_row_key);
    this.select_row_key = select_row_key;
  }
  // menu_id更改
  async getMenuId() {
    const { data }: any = await client.get(`${API.product_menu}?product_code=hundun`);
    this.user_list_id = data.menu_list[1].id;
  }
  beforeCreate() {
    this.more_form = this.$form.createForm(this);
  }
  created() {
    this.search(1);
    this.getMenuId();
  }
}
